import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";
import { useLoading } from "components/GlobalLoading";
import { useLogsProtestoConta } from "features/conta/hooks";

import { CloseModalButton } from "components/Button/CloseModalButton";
import TimelineLogs from "components/TimelineLogs";

interface ModalHistoricoProtestoProps {
  contaId?: string;
  isOpenModal: boolean;
  onClose: () => any;
}

export default function ModalHistoricoProtesto({
  contaId,
  isOpenModal,
  onClose,
}: ModalHistoricoProtestoProps) {
  const { data, isFetching } = useLogsProtestoConta(contaId);

  useLoading(isFetching);

  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="500px"
        footer={
          <Flex flex={1} justifyContent="end" gap={4}>
            <CloseModalButton
              showBorder={false}
              close={onClose}
              closeModalLabel="Fechar"
            />
          </Flex>
        }
        visible={isOpenModal}
        onCancel={onClose}
      >
        <Flex>
          <Heading mb={4} size="md">
            Histórico de protesto
          </Heading>
        </Flex>
        <Flex py="4px" flexDir={"column"}>
          {data?.map((item, key) => (
            <TimelineLogs key={key} data={item} />
          ))}
        </Flex>
      </Modal>
    </>
  );
}
